import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams,Platform } from 'ionic-angular';
import JsBarcode from 'jsbarcode';
import { Printer, PrintOptions } from '@ionic-native/printer';
import { CajaProvider } from '../../providers/caja/caja'
import { Storage } from '@ionic/storage'

@IonicPage()
@Component({
  selector: 'page-impresora-bluetooth',
  templateUrl: 'impresora-bluetooth.html',
  providers: [Printer]
})
export class ImpresoraBluetoothPage {
  @ViewChild('canvasOld') canvasElement : ElementRef;
  valores = []
  botonNoMostrar:boolean=true
  reciboCaja:string=""
  imagen:string=''
  canvasVer:boolean=false
  data = ''
  imagenEntidad:string="assets/imgs/icon.png"
  codigo:any
  mostrarImagen:boolean=false
  constructor(public navCtrl: NavController, public navParams: NavParams,
              private printer: Printer,
              public servicio: CajaProvider,
              public storage:Storage,public platform:Platform) {

                this.valores = this.navParams.get('item')
                this.imagen = this.navParams.get('imagen')
                this.codigo = this.navParams.get('codigo')

                if(this.valores == undefined) {
                  let data = this.navParams.get('data')
                  this.codigo =data.nombre.replace("Placa ", "").replace("placa ", "").replace("Placa","").replace("placa","");
                  this.servicio.imprimirReciboCajaComandasParqueaderosPorGestion(data.turno,data.companiasId)
                  .subscribe((data)=>{

                    let mensajeafn = JSON.parse(data['_body'])
                    let mensajes = mensajeafn.data[0]
                    let imagen = mensajeafn.data[1]
                    if(imagen.length>0) {
                      this.imagen = imagen[0].imagen
                    } else {
                      this.imagen = " "
                    }
                    if (mensajes.length > 2 && mensajes[2].reciboCaja.trim() === "Placa undefined") {
                      mensajes[2].reciboCaja = this.codigo;
                    }
                   this.valores = mensajes

                   this.imagenEntidad = this.imagen
                   this.mostrarImagen = this.imagen.length>5 ? true : false
                       setTimeout(()=>{
                         if (this.platform.is('android')) {
                           this.imprimirAndroid(this.valores)
                         }else{
                           this.imprimirDataPrint()
                         }

                       },1000)
                 },
               )}
            }

            imprimirAndroid(recibo:any){
              this.printer.isAvailable().then();

              let options: PrintOptions = {
                   name: 'MyDocument',
                   printerId: 'printer007',
                   duplex: true,
                   landscape: true,
                   grayscale: true
                 };

              this.printer.print(recibo, options).then();
            }

  ionViewDidLoad() {
  }

  imprimirDataPrint(){
    if(window){
      this.botonNoMostrar = false
      // if(this.mostrarImagen){
        this.canvasElementcodigo(this.codigo)
      // }
      window.print();
      this.navCtrl.pop();
     } else {
        alert("window is not defined");
     }
  }
  imprimirData(){


 if(this.navParams.get('item')){
                  let mensaje = this.navParams.get('item')
                  let recibo = ''

                  let queImprimo = 0
                  this.codigo =  mensaje.codigo
                  if(this.codigo===undefined){
                    this.codigo =  mensaje.factura
                    queImprimo = 1
                  }

                  this.imagen = this.navParams.get('imagen')
                  this.mostrarImagen = this.imagen.length>5 ? true : false
                  this.canvasVer = this.navParams.get('canvas')

                  this.storage.get('companiasId').then((val) => {

                    this.servicio.buscarParametrosGenerales(val)
                    .subscribe((data)=>{

                      this.imagenEntidad = data[0].imagen

                     if(queImprimo==1){

                      this.servicio.imprimirFactura(this.codigo,val)
                      .subscribe((data)=>{

                         let mensajeafn = JSON.parse(data['_body'])
                         let mensajes = mensajeafn[0]
                         this.valores = mensajes
                      },
                    )
                  }else{
                    this.servicio.imprimirComandasMesas(this.codigo,val)
                    .subscribe((data)=>{

                      let mensajeafn = JSON.parse(data['_body'])
                      let mensajes = mensajeafn[0]
                      this.valores = mensajes
                   },
                 )
                  }


                    })

                })

              }

  }

  onSuccess(data){

  }
  onError(error){

  }
  imprimir(){
    this.botonNoMostrar = false
    this.canvasElementcodigo(this.codigo)
      if(window){
       window.print();
       this.navCtrl.pop();
      } else {
          console.warn("window is not defined");
      }
  }

  canvasElementcodigo(codigo){
   this.canvasElement.nativeElement.style ="display:block"
   this.canvasElement.nativeElement.style.textAlign = "left";
    JsBarcode(this.canvasElement.nativeElement, codigo, {
      format: "CODE128",
      displayValue: true,
      fontSize: 20,
      height: 40,
      width: 2,
      fontOptions: "bold"
    });
}

ngAfterViewInit() {
  this.canvasNoDefinido()
}

canvasNoDefinido(){
  JsBarcode(this.canvasElement.nativeElement, "No definido", {
      fontSize: 20,
      background: "#0000",
      lineColor: "",
      margin: 20,
      marginLeft: 20
    });
}
}



// WEBPACK FOOTER //
// ./src/pages/impresora-bluetooth/impresora-bluetooth.ts